<script setup lang="ts">
const { t } = useI18n();
const { decided, acceptAll, refuseAll, openModal } = useCookieConsent();

const ui = {
  overlay: "bg-blue-800/40! z-40!",
  content:
    "top-auto! bottom-0! left-0! right-0! translate-x-0! translate-y-0! max-w-none! w-full! max-h-none! rounded-none! shadow-none! ring-0! bg-white! overflow-visible! divide-y-0! z-40!",
};
</script>

<template>
  <UModal
    :open="!decided"
    :overlay="true"
    :dismissible="false"
    :close="false"
    :modal="true"
    :transition="false"
    :title="t('cookies.banner.text')"
    :ui="ui"
  >
    <template #content>
      <UContainer class="flex flex-col lg:flex-row lg:items-center gap-4 p-5">
        <p class="grow text-base text-black leading-snug">
          {{ t("cookies.banner.text") }}
        </p>
        <div class="flex flex-wrap items-center gap-2 shrink-0">
          <UButton color="secondary" size="md" @click="acceptAll">
            {{ t("cookies.acceptAll") }}
          </UButton>
          <UButton variant="outline" color="primary" size="md" @click="refuseAll">
            {{ t("cookies.refuseAll") }}
          </UButton>
          <UButton variant="outline" color="primary" size="md" @click="openModal">
            {{ t("cookies.customize") }}
          </UButton>
        </div>
      </UContainer>
    </template>
  </UModal>
</template>
